// extracted by mini-css-extract-plugin
export var icon = "_7j-1";
export var subtext = "_7j-0";